import { z } from 'zod';
export const UsageQuery = z.object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
/**
 * Query for the paginated "recent calls" list. Extends the date filter with
 * cursor-based pagination, mirroring the payment-log convention: `cursor` is an
 * OPAQUE composite (`${createdAtMsISO}|${id}` of the last row seen) — clients
 * pass back the previous page's `nextCursor` verbatim and must not parse it.
 * Rows are ordered `(created_at DESC, id DESC)`; the keyset advances strictly
 * past the cursor so rows sharing a `created_at` are never skipped.
 */
export const RecentCallsQuery = UsageQuery.extend({
    limit: z.coerce.number().int().positive().max(200).optional(),
    cursor: z.string().min(1).optional(),
});
export const UsageSummaryDTO = z.object({
    totals: z.object({
        calls: z.number().int(),
        inputTokens: z.number().int(),
        outputTokens: z.number().int(),
        totalTokens: z.number().int(),
        errorRate: z.number(),
    }),
    byTaskModel: z.array(z.object({
        task: z.string(),
        model: z.string(),
        calls: z.number().int(),
        totalTokens: z.number().int(),
        errorRate: z.number(),
    })),
    byDay: z.array(z.object({ day: z.string(), calls: z.number().int(), totalTokens: z.number().int() })),
});
export const RecentCallDTO = z.object({
    id: z.guid(),
    createdAt: z.string().datetime(),
    task: z.string(),
    model: z.string(),
    totalTokens: z.number().int(),
    ok: z.boolean(),
    error: z.string().nullable(),
    conversationId: z.guid().nullable(),
});
/**
 * Paginated envelope for the recent-calls list. `nextCursor` is an OPAQUE
 * composite token to pass back as `cursor` for the following page, or `null`
 * when the current page is the last one. Clients must not parse it.
 */
export const RecentCallsPageDTO = z.object({
    items: z.array(RecentCallDTO),
    nextCursor: z.string().min(1).nullable(),
});
//# sourceMappingURL=llm-usage.js.map